import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
//import { of } from "rxjs";
import { map, switchMap } from "rxjs/operators";
import * as type from "./actionTypes";
import * as UserManagementAction from "./actions";
import { UserManagementService } from "./service";

@Injectable()
export class UserManagementEffect {
  constructor(
    private action: Actions,
    private userManagementService: UserManagementService
  ) {}

  GetUserList = createEffect(() =>
    this.action.pipe(
      ofType(type.GET_USER_LIST),
      switchMap((data: any) => this.userManagementService.getUserList()),
      map((data: Array<any>) => new UserManagementAction.UserList(data))
    )
  );

  UserById = createEffect(() =>
    this.action.pipe(
      ofType(type.SEARCH_USER_BY_ID),
      switchMap((data: any) => this.userManagementService.getUserById(data.payload)),
      map((data: Array<any>) => new UserManagementAction.UserById(data))
    )
  );

  AddUser = createEffect(() =>
    this.action.pipe(
      ofType(type.ADD_USER),
      switchMap((data: any) => this.userManagementService.addUser(data.payload)),
      map((data: any) => new UserManagementAction.AddUserResponse(data))
    )
  );

  UpdateUser = createEffect(() =>
    this.action.pipe(
      ofType(type.UPDATE_USER),
      switchMap((data: any) => this.userManagementService.updateUser(data.payload)),
      map((data: any) => new UserManagementAction.UpdateUserResponse(data))
    )
  );

  DeleteUser = createEffect(() =>
    this.action.pipe(
      ofType(type.DELETE_USER),
      switchMap((data: any) => this.userManagementService.deleteUser(data.payload)),
      map((data: any) => new UserManagementAction.DeleteUserResponse(data))
    )
  );

  SearchUserByFields = createEffect(() =>
    this.action.pipe(
      ofType(type.SEARCH_USER_BY_FIELD),
      switchMap((data: any) => this.userManagementService.searchUserByFields(data.payload)),
      map((data) => new UserManagementAction.UserByFieldList(data))
    )
  );

  GetUserListByPartnerId = createEffect(() =>
    this.action.pipe(
      ofType(type.GET_USER_LIST_BY_PARTNER_ID),
      switchMap((data: any) => this.userManagementService.getUserListByPartnerId(data.payload)),
      map((data: Array<any>) => new UserManagementAction.UserListByPartnerId(data))
    )
  );

  GetPartnersList = createEffect(() =>
    this.action.pipe(
      ofType(type.GET_PARTNERS_LIST),
      switchMap((data: any) => this.userManagementService.getPartnersList()),
      map((data: Array<any>) => new UserManagementAction.PartnersList(data))
    )
  );

  GetAdminsList = createEffect(() =>
    this.action.pipe(
      ofType(type.GET_ADMIN_LIST),
      switchMap((data: any) => this.userManagementService.getAdminsList(data.payload)),
      map((data: Array<any>) => new UserManagementAction.AdminList(data))
    )
  );
}
